RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.OnboardingModal = Marionette.ItemView.extend({

        ui: {
            modal: '.modal',
            scheduleButton: '.x-schedule',
            closeButton: '.x-close'
        },

        events: {
            'shown.bs.modal': 'onModalShown',
            'click @ui.scheduleButton': 'onSchedule',
            'click @ui.closeButton': 'onClose'
        },

        template: '#onboardingModalTemplate',

        templateHelpers: function () {
            const me = this;
            const csm = me.getCsm();
            const csmName = _.get(csm, ['Name'], '');
            const csmFirstName = csmName.split(' ')[0];
            return {
                csmName: csmFirstName,
                getsPersonalizedOnboarding: me.options.getsPersonalizedOnboarding
            };
        },

        getCsm: function () {
            const me = this;
            return (me.options.csm || RivalIQ.state.account.get('csm'));
        },

        onRender: function () {
            const me = this;
            me.ui.modal.modal();
        },

        onModalShown: function () {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedOnboardingModal);
        },

        onSchedule: function () {
            const me = this;

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedScheduleInOnboardingModal);

            // sending the Sold By NBQ customers to a team calendar, sending others to the webinar
            const calendlyUrl = me.options.getsPersonalizedOnboarding ? 'https://calendly.com/rival-iq-customer-success/30-minutes' : 'https://calendly.com/riq-onboarding/45';
            window.open(calendlyUrl, '_blank');
            me.onClose();
        },

        onClose: function () {
            const me = this;
            me.ui.modal.modal('hide');

            // NOTE reload on close, if specified
            if (me.options.reloadOnSuccess) {
                window.location.reload();
            }
        }

    });

});
